var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconInternational40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18963)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 35.5029C28.2843 35.5029 35 28.7872 35 20.5029C35 12.2187 28.2843 5.50293 20 5.50293C11.7157 5.50293 5 12.2187 5 20.5029C5 28.7872 11.7157 35.5029 20 35.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_18963",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 30,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 35.5029C28.2843 35.5029 35 28.7872 35 20.5029C35 12.2187 28.2843 5.50293 20 5.50293C11.7157 5.50293 5 12.2187 5 20.5029C5 28.7872 11.7157 35.5029 20 35.5029Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_18963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 35.5029C28.2843 35.5029 35 28.7872 35 20.5029C35 12.2187 28.2843 5.50293 20 5.50293C11.7157 5.50293 5 12.2187 5 20.5029C5 28.7872 11.7157 35.5029 20 35.5029Z",
    stroke: "#918F90",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2479 4.73364C21.1669 5.92913 20.1081 7.43327 20.0715 9.24606C20.0166 11.9653 23.5721 10.504 23.5721 12.4676C23.5721 14.4311 21.2542 14.7935 19.1688 12.7974C17.0834 10.8013 14.7728 10.5758 12.7016 12.3601C10.6303 14.1445 10.29 18.8391 13.8575 19.5658C17.425 20.2926 17.945 20.5757 17.945 24.187C17.945 27.7982 18.4148 28.5798 21.2113 28.5798C24.0079 28.5798 22.513 25.6589 23.5721 23.7669C24.6312 21.8749 26.4615 20.8875 26.4615 19.3493C26.4615 17.811 22.9089 18.077 23.5721 15.9297C24.2353 13.7824 27.3826 14.9463 28.9086 14.0493C30.4345 13.1523 31.4782 9.62715 31.0616 9.24606C30.8694 9.07019 30.1813 8.07364 28.0713 6.78668C27.3116 6.32332 26.7278 5.72927 25.8028 5.43342C25.0937 5.14773 24.242 4.91447 23.2479 4.73364Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 35.5029C28.2843 35.5029 35 28.7872 35 20.5029C35 12.2187 28.2843 5.50293 20 5.50293C11.7157 5.50293 5 12.2187 5 20.5029C5 28.7872 11.7157 35.5029 20 35.5029Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconInternational40);
export default __webpack_public_path__ + "static/media/pictogramBeaconInternational40.fa92549fe25c559218c68385332968e3.svg";
export { ForwardRef as ReactComponent };